<div id="app-claim-ticket-verification" class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="center center">
            <span> Verification</span>
        </mat-toolbar-row>
    </mat-toolbar>
    <mat-divider></mat-divider>
    <div mat-dialog-content>
       
            <div fxLayout="row wrap" fxFlex="100%" fxLayoutAlign="center center" class="p-lr-15">

                <div fxFlex="100%">
                    <mat-form-field class="w-100">
                        <mat-label>Verification Code</mat-label>
                        <input matInput name="codeOTP" [(ngModel)]="codeOTP"  required> 
                    </mat-form-field>
                </div>

                <div fxFlex="100%" fxLayoutAlign="center center" class="mtb-5">
                    <button mat-flat-button class="flat-primary-button" (click)="verifyTicketOTP()">
                        Verify
                    </button>
                </div>
       
            </div>
            
    </div>
</div>